import { apiFetch } from "assets/api";
import * as React from 'react';
import {
    Grid, Card, TextField, CardContent, Box, 
    Typography, Divider,
    CircularProgress,
    CardActionArea,
  } from '@mui/material'

import SearchCard from "components/SearchCard";
import constants from 'assets/constants';
import { stripAccents, apiUrl } from 'assets/utils';
import { useTranslation } from "react-i18next";

async function fetchClubList(s) {
    const data = await apiFetch(apiUrl("/list_clubs?s=" + s));
    const content = await data.json();
    
    return content;
}

function tokenSearch(list, s) {
    const tokens = s.split(" ");

    if (list === undefined || list == null) {
        return []
    }

    return list.filter(player => {
        const c = stripAccents(player["name"].replace(".", ""));

        for (var i = 0; i < tokens.length; ++i) {
            const token = tokens[i];
            
            if (!c.includes(stripAccents(token))) {
                return false;
            }
        }

        return true;
    })
}

export default function ClubSearchCard ({fetchData}) {

    const { t } = useTranslation()

    return <SearchCard
        fetchData={fetchData}
        fetchList={fetchClubList}
        searchMethod={tokenSearch}
        MIN_LENGTH = {3}
        generalText={{placeholder: t("search.clubPlaceholder"), noResults: t("search.clubNoResults")}}
        listItem={(index, el, handleClick) => 
            <React.Fragment key={el["name"] + el["club_id"]}>
            {index > 0? <Divider/> : null}
            <CardActionArea onClick={()=>{handleClick(el)}} sx={{pl: 2, pt: 1.25, pb: 1}}>
            <Typography variant="body2" sx={{fontWeight: "bold"}} color="text.primary_bold">{el["name"]}</Typography>
            <Typography variant="caption" color="text.secondary">{t("club.members", {count: el.num_members})}</Typography>
            </CardActionArea>

            </React.Fragment>
        }

    />
}